export default __webpack_public_path__ + "static/media/homepageLogo.601ecc57.jpg";